import { render, staticRenderFns } from "./SecureLink_4_2.vue?vue&type=template&id=5c484bec"
import script from "./SecureLink_4_2.vue?vue&type=script&lang=js"
export * from "./SecureLink_4_2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports